module.exports = __webpack_public_path__ + "static/media/IMG_7275_DxO.f3cf1c0b.jpg";